import { combineReducers } from "redux";
import AdminReducer from "./AdminReducer";
import UserReducer from "./UserReducer";

export default combineReducers({
  AdminReducer,
  UserReducer,
});
